import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "41716b50-438d-476e-aa73-0eb6f90a929c";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
  ];
  const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
  ];
class UpdatePriceGridPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }
    
    loadState() {
       // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
      }
    
      saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
      }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <Scrolling mode="virtual" useNative={false} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />

                    <Column
                        dataField="recordNo"
                        caption="Record #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="itemCode"
                        caption="Item"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="itemDesc1"
                        caption="Item Description - 1"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="lotCode"
                        caption="Lot"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="idGroup"
                        caption="Customer Group"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="idSubGroup"
                        caption="Customer Sub Group"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="invoiceDate"
                        caption="Invoice Date"
                        dataType="date"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="name"
                        caption="Customer Name"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="productCategoryCode"
                        caption="Product Category"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="discountedPrice"
                        caption="Discount Price"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="discountedForeignPrice"
                        caption="Discount Price (Foreign)"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="transCurrencyType"
                        caption="Transaction Currency Type"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="payCurrencyType"
                        caption="Pay Currency Type"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="transactionCurrency"
                        caption="Transaction Currency"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="payCurrency"
                        caption="Pay Currency"
                        allowEditing={false}

                    ></Column>
                 
                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UpdatePriceGridPreview);